import Nft from '../Assets/image/NFT.png';
import Octo from '../Assets/image/Octo.png';
import Optima from '../Assets/image/Optima.png';
import Personify from '../Assets/image/Personify.png';
import Celestals from '../Assets/image/Celestals.png';
import GlobalPayment from '../Assets/image/GlobalPayment.png';
import Dashboard from '../Assets/image/Dashboard.png';
import FinTech from '../Assets/image/FinTech.png';
import ArchibaldLondon from '../Assets/image/ArchibaldLondon.png';
import { ISelectedWork } from '../Types/SelectedWorks';

export const images:ISelectedWork[] = [
	{
		id: 0,
		src: Personify,
	},
	{
		id: 1,
		src: Celestals
	},
	{
		id: 2,
		src: Optima
	},
	{
		id: 3,
		src: Octo
	},
	{
		id: 4,
		src: Nft
	},
	{
		id: 5,
		src: GlobalPayment
	},
	{
		id: 6,
		src: Dashboard
	},
	{
		id: 7,
		src: ArchibaldLondon
	},
	{
		id: 8,
		src: FinTech
	}

];